import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { translate } from "../i18n/strings";

const STORAGE_KEY = "gourmeto.lang";
const LanguageContext = createContext(null);

function readLang() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (v === "en" || v === "fr") return v;
  } catch {
    // ignore
  }
  try {
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("fr")) return "fr";
  } catch {
    // ignore
  }
  return "en";
}

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(readLang);

  const toggleLang = useCallback(() => {
    setLocale((prev) => {
      const next = prev === "fr" ? "en" : "fr";
      try {
        window.localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // ignore
      }
      return next;
    });
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const t = useCallback((key, vars) => translate(locale, key, vars), [locale]);

  const value = useMemo(
    () => ({ locale, isFr: locale === "fr", t, toggleLang }),
    [locale, t, toggleLang],
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
};
